import { IMAGE_TYPES } from '../constants';

const mimeType = headerString => {
  if ('89504e47'.match(headerString)) {
    return IMAGE_TYPES.PNG;
  }
  if (['ffd8ffe0', 'ffd8ffe1', 'ffd8ffe2'].some(type => Boolean(type.match(headerString)))) {
    return IMAGE_TYPES.JPEG;
  }
  return null;
};

export const getBLOBFileReader = blob => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();

    fileReader.onloadend = e => {
      const arr = new Uint8Array(e.target.result).subarray(0, 4);
      let header = '';
      for (let i = 0; i < arr.length; i++) {
        header += arr[i].toString(16);
      }
      resolve(mimeType(header));
    };

    fileReader.onerror = () => {
      reject(new Error('An error occurred while reading the file'));
    };

    fileReader.readAsArrayBuffer(blob);
  });
};
